<ng-container *ngIf="isPickingLocation">
  <i class="fa fa-check-circle is-pick-location">&nbsp;</i>
</ng-container>
